import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=a63a26c6&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=a63a26c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a26c6",
  null
  
)

export default component.exports